import { PropsWithChildren, useCallback, useEffect } from 'react'

import { Form as AbstractForm, FormInstance, FormProps, FormRule } from 'antd'

import { useLoading } from '@data-client/hooks'

import { Item } from '../form/index'
import { OverlayLoader } from '../loader'

type FormRuleProps<T> = {
  [key in keyof T]: FormRule[]
}

const Form = <T,>({
  onValidate = () => {},
  initialValues,
  onChange,
  form,
  ...props
}: PropsWithChildren<FormProps<T> & { onValidate?: (valid: boolean, values: T) => void }>) => {
  const handleValidate = useCallback(
    async (form: FormInstance) =>
      await form
        .validateFields()
        .then((values) => ({ valid: true, values }))
        .catch((values) => ({ valid: false, values })),
    [],
  )

  const [validate, loading] = useLoading(handleValidate, [])

  useEffect(() => {
    initialValues && form && validate(form).then(({ valid, values }) => onValidate(valid, values))
  }, [form, initialValues, onValidate, validate])

  return (
    <OverlayLoader loading={loading}>
      <AbstractForm<T> initialValues={initialValues} form={form} layout={'vertical'} size={'middle'} {...props}>
        {props.children}
      </AbstractForm>
    </OverlayLoader>
  )
}

Form.Item = (props) => <Item {...props} />

export { Form, type FormProps, type FormRuleProps }
